export default {
  logs: state => state.logs,
  errors: state => state.errors
};
